import React, { useState, useEffect, useCallback } from "react";
import { PageHeader, Row, Col, Card, DatePicker, Collapse, Checkbox } from "antd";
import { API, API_BASE_URL, API_TXFRAUD} from "../../config/config";
import PermissionsRequired from "../../helper/PermissionsRequired";
import axios from "axios";
import moment from "moment";
import Cookies from "js-cookie";
import AlertsLineChart from "./AlertsLineChart";
import AlertsPieChart from "./AlertsPieChart";
import Analytics from "./Analytics";
import AlertsTask from "./AlertsTask";
// import moment from "moment";
import UserSettings from "../../helper/UserSettings";
import MenuAccess from "../../helper/MenuAccess";
import {  DISABLE_ALERTS, DISABLE_PAYMENTS,DISABLE_CHARGEBACKS } from "../../config/config";
import ChargebackStats from "./ChargebackStats";
import ChargebackIssuer from "./ChargebackIssuer";
import { UpOutlined, DownOutlined } from "@ant-design/icons";
import FraudCheckPieChart from "./FraudCheckPieChart";
import FraudCheckLineChart from "./FraudCheckLineChart";


const { RangePicker } = DatePicker;
const DATA_URL = "/alertschart/";
const DATA_URL_FRAUDCHECK = API_TXFRAUD + '/fraudchecks/charts';
const DATA_URL_ANALYTICS = "/analytics/";
const DATA_URL_ALERTS_TASK = "/alertstask/";

const DEFAULT_DATE_RANGE = 7;
const DEFAULT_DATE_PERIOD = "days";
const START_DATE = moment().subtract(DEFAULT_DATE_RANGE, DEFAULT_DATE_PERIOD);
const END_DATE = moment();
const dateFormat = "YYYY/MM/DD";

const Dashboard = (props) => {
    const { t } = props;
    const [data, setData] = useState(null);
    const [fraudcheckData, setFraudcheckData] = useState(null);
    const [alertsTask, setAlertsTask] = useState(null);
    const [analytics, setAnalytics] = useState(null);
    const monthNames = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];
    const dateToGetMonth = new Date();
    const currentMonthName = monthNames[dateToGetMonth.getMonth()];
    const [dates, setDates] = useState([START_DATE, END_DATE]);
    const [fraudcheckDates, setFraudcheckDates] = useState([START_DATE, END_DATE]);
    const [isOpen, setIsOpen] = useState(false);
    const [alertWidget, setAlertWidget] = useState(null);
    const [transactionWidget, setTransactionWidget] = useState(null);
    const [updateSettings] = UserSettings();
    const [checkShowAllAlertWidget, setCheckShowAllAlertWidget] = useState(false);
    const [checkShowAllTransactionWidget, setCheckShowAllTransactionWidget] = useState(false);

    const [checkShowAllChargebackWidget, setCheckShowAllChargebackWidget] = useState(true);
    const [chargebackStats, setChargebackStats] = useState(null);
    const [chargebackIssuer, setChargebackIssuer] = useState(null);
    const [showAllChargebackWidget, setShowAllChargebackWidget] = useState(false);
    
    function handleCheckFromAlertWidget(data) {
        setCheckShowAllAlertWidget(data);
    }

    function handleCheckFromTransactionWidget(data) {
        setCheckShowAllTransactionWidget(data);
    }




    

    useEffect(() => {
        if (!data) {
            // getAlertsTask();
            // getAnalytics();
            getAggregates();
        }
        if(!analytics){
            getAnalytics();
        }
        if(!alertsTask){
            getAlertsTask();
        }

        if(!chargebackStats){
            getChargebackStats();
        }
        if (!chargebackIssuer) {
            getChargebackIssuer();
        }
        if(!fraudcheckData) {
            getFraudCheckAggregates();
        }

        loadAlertWidgetShowAll();
        loadTransactionWidgetShowAll();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // useEffect(() => {
    //     if (unix) {
    //         getAnalytics();
    //         getAggregates();
    //     }
    // }, [unix]); // eslint-disable-line react-hooks/exhaustive-deps

    const getAggregates = () => {
        const apiUrl = DATA_URL;
        axios
            .get(API + apiUrl +"?date_to="+dates[1].format('YYYY-MM-DD')+"&date_from="+dates[0].format('YYYY-MM-DD'),
                { headers: { Authorization: "Bearer " + Cookies.get("access_token") } })
            .then(({ data }) => {
                setData(data);
            })
            .catch((error) => error);
    };

    const getFraudCheckAggregates = useCallback(() => {
        const apiUrl = DATA_URL_FRAUDCHECK;
        axios
            .post(apiUrl,
                {
                    date_from: fraudcheckDates[0].format('YYYY-MM-DD'),
                    date_to: fraudcheckDates[1].format('YYYY-MM-DD'), 
                },
                { headers: { Authorization: "Bearer " + Cookies.get("access_token") } })
            .then(({ data }) => {
                if(!data?.fraudcheck?.piechart && !data?.fraudcheck?.linechart)
                    return;

                if(!Array.isArray(data?.fraudcheck?.piechart) || data?.fraudcheck?.piechart.length === 0) {
                    data.fraudcheck.piechart = [];
                    data.fraudcheck.piechart.push({response: 'DECLINED', value: '0'})
                    data.fraudcheck.piechart.push({response: 'APPROVED', value: '0'})
                    data.fraudcheck.piechartRate = 'N/A';
                } else {
                    let pieChartDeclinedIndex = data.fraudcheck.piechart.findIndex(val => val.response.toLowerCase() === 'declined');
                    let pieChartApprovedIndex = data.fraudcheck.piechart.findIndex(val => val.response.toLowerCase() === 'approved');
                    /*
                    * decline piechart count not found
                    * append declined -- value 0 
                    * set approval rate as 100%
                    */
                    if(pieChartDeclinedIndex < 0) {
                        data.fraudcheck.piechart.push({response: 'DECLINED', value: '0'})
                        data.fraudcheck.piechartRate = '100%';
                    } else if(pieChartApprovedIndex < 0) {
                        data.fraudcheck.piechart.push({response: 'APPROVED', value: '0'})
                        data.fraudcheck.piechartRate = '0%';
                    } else {
                        // calculate the approved percentage
                        const approvedValue = Number(data.fraudcheck.piechart[pieChartApprovedIndex].value) || 0;
                        const declinedValue = Number(data.fraudcheck.piechart[pieChartDeclinedIndex].value) || 0;
                        const totalCount = approvedValue + declinedValue;
                        data.fraudcheck.piechartRate = totalCount > 0
                            ? ((approvedValue / totalCount) * 100).toFixed(2) + "%"
                            : '0%';
                    }
                }
                setFraudcheckData(data);
            })
            .catch((error) => {
                console.error('Failed to fetch fraud check aggregates:', error);
            });
    }, [fraudcheckDates]);

    const getAnalytics = () => {
        const apiUrl = DATA_URL_ANALYTICS;
        axios
            .get(API + apiUrl, { headers: { Authorization: "Bearer " + Cookies.get("access_token") } })
            .then(({ data }) => {
                setAnalytics(data);
                setTransactionWidget(loadTransactionWidget(data));
            })
            .catch((error) => error);
    };

    const getAlertsTask = () => {
        const apiUrl = DATA_URL_ALERTS_TASK;
        axios
            .get(API + apiUrl, { headers: { Authorization: "Bearer " + Cookies.get("access_token") } })
            .then(({ data }) => {
                setAlertsTask(data);
                setAlertWidget(loadAlertWidget(data));
            })
            .catch((error) => error);
    };


    const getChargebackStats = () => {
        const apiUrl = `${API_BASE_URL}/v3/chargeback/chargebackStats`;
        axios
        .get(apiUrl, { headers: { Authorization: "Bearer " + Cookies.get("access_token") } })
        .then(({ data }) => {
            setChargebackStats(data);   
        })
        .catch((error) => error);
    };

    const getChargebackIssuer = () => {
        const apiUrl = `${API_BASE_URL}/v3/chargeback/getChargebackIssuer`;
        axios
        .get(apiUrl, { headers: { Authorization: "Bearer " + Cookies.get("access_token") } })
        .then(({ data }) => {
            setChargebackIssuer(data);   
        })
        .catch((error) => error);
    };


    const checkTranslation = (datas) => {
        return datas
            ? datas.map((data) => {
                  try {
                      if (data.type.toLowerCase() && data.type[0].toUpperCase() !== data.type[0].toLowerCase()) {
                          return { ...data, type: t(`${data.type}`).charAt(0).toUpperCase() + t(`${data.type}`).slice(1) };
                      }
                  } catch (error) {
                      return data;
                  }
                  return data;
              })
            : [];
    };

    const onDatesChange = (val) => {
        setDates(val);
    };

    const onDatesChangeFraudCheckChart = (val) => {
        setFraudcheckDates(val);
    }


    useEffect(() => {
      if (!isOpen && dates && dates[0] && dates[1]) {
        getAggregates();
      }
    }, [dates, isOpen]);// eslint-disable-line 

    useEffect(() => {
      if (fraudcheckDates && fraudcheckDates[0] && fraudcheckDates[1]) {
        getFraudCheckAggregates();
      }
    }, [fraudcheckDates, getFraudCheckAggregates]);

    const onOpenChange = (open) => {
        setIsOpen(open);
    };

    const onShowAllAlertWidget = (e) => {
        if(e.target.checked){
            let loggedUserSettings = localStorage.getItem("loggedUserSettings") ? JSON.parse(localStorage.getItem("loggedUserSettings")) : null;
            if (loggedUserSettings) {
                if (loggedUserSettings.hideAlertWidget) {
                    loggedUserSettings.hideAlertWidget = [];
                    updateSettings(loggedUserSettings);
                    localStorage.setItem("loggedUserSettings",JSON.stringify(loggedUserSettings));
                    setAlertWidget(loadAlertWidget(alertsTask));
                    loadAlertWidgetShowAll();
                }
            }
        }
    };

    const onShowAllTransactionWidget = (e) => {
        if(e.target.checked){
            let loggedUserSettings = localStorage.getItem("loggedUserSettings") ? JSON.parse(localStorage.getItem("loggedUserSettings")) : null;
            if (loggedUserSettings) {
                if (loggedUserSettings.hideTransactionWidget) {
                    loggedUserSettings.hideTransactionWidget = [];
                    updateSettings(loggedUserSettings);
                    localStorage.setItem("loggedUserSettings",JSON.stringify(loggedUserSettings));
                    setTransactionWidget(loadTransactionWidget(analytics));
                    loadTransactionWidgetShowAll();
                }
            }
        }
    };

    const loadAlertWidget = (alertsTask) => {
        return <AlertsTask t={t} data={alertsTask ? alertsTask.alerts_task : null} alertWidgetUpdate={handleCheckFromAlertWidget} />;
    };

    const loadTransactionWidget = (analytics) => {
        return <Analytics t={t} data={analytics ? analytics.analytics : null} transactionWidgetUpdate={handleCheckFromTransactionWidget} /> 
    };

    const loadChargebackWidget = () => {
        return <ChargebackStats t={t} data={chargebackStats} showAll={checkShowAllChargebackWidget} setCheckShowAllChargebackWidget={setCheckShowAllChargebackWidget} /> 
    };

    const loadChargebackIssuerWidget = () => (
    <ChargebackIssuer
        t={t}
        data={chargebackIssuer}
        showAll={showAllChargebackWidget}
    />
    );



    const loadAlertWidgetShowAll = () => {
        let loggedUserSettings = localStorage.getItem("loggedUserSettings") ? JSON.parse(localStorage.getItem("loggedUserSettings")) : null;
        if(loggedUserSettings){
            if(!loggedUserSettings.hideAlertWidget || loggedUserSettings.hideAlertWidget === null || (loggedUserSettings.hideAlertWidget && loggedUserSettings.hideAlertWidget.length === 0)){
                setCheckShowAllAlertWidget(true);
            } else {
                setCheckShowAllAlertWidget(false);
            } 
        }  else
        {
            setCheckShowAllAlertWidget(false);
        }
    };

    const loadTransactionWidgetShowAll = () => {
        let loggedUserSettings = localStorage.getItem("loggedUserSettings") ? JSON.parse(localStorage.getItem("loggedUserSettings")) : null;
        if(loggedUserSettings){
        if(!loggedUserSettings.hideTransactionWidget || loggedUserSettings.hideTransactionWidget === null || (loggedUserSettings.hideTransactionWidget && loggedUserSettings.hideTransactionWidget.length === 0)){
            setCheckShowAllTransactionWidget(true);
        } else {
            setCheckShowAllTransactionWidget(false);
        }   
       }else{
        setCheckShowAllTransactionWidget(false);
       }
    };

    return (
        <div>
            <PageHeader title={t("contents.dashboard.title")}></PageHeader>

            {MenuAccess('alerts') && !DISABLE_ALERTS? (
                <Collapse style={{ marginBottom: "1.5rem" }} defaultActiveKey={['1']}>
                    <Collapse.Panel header={t("contents.dashboard.alert_info")} key="1"
                        extra={[
                            <div key="show_all_alert_widget"  onClick={(e) => e.stopPropagation()}>
                                <Checkbox
                                    onChange={onShowAllAlertWidget}
                                    checked={checkShowAllAlertWidget}
                                >Show all</Checkbox>
                            </div>
                        ]}
                    >
                        {!alertWidget ? setAlertWidget(loadAlertWidget(alertsTask)) : alertWidget}
                    </Collapse.Panel>
                </Collapse>
                ) : null
            }

            <div>
                {MenuAccess('payments') && !DISABLE_PAYMENTS ? (
                    <Collapse style={{ marginBottom: "1.5rem" }} defaultActiveKey={['t1']}>
                        <Collapse.Panel header={t("contents.dashboard.transaction_info")} key="t1"
                            extra={[
                                <div key="show_all_transaction_widget"  onClick={(e) => e.stopPropagation()}>
                                    <Checkbox
                                        onChange={onShowAllTransactionWidget}
                                        checked={checkShowAllTransactionWidget}
                                    >Show all</Checkbox>
                                </div>
                            ]}
                        >
                            {/* <Analytics t={t} data={analytics ? analytics.analytics : null} />  */}
                            {!transactionWidget ? setTransactionWidget(loadTransactionWidget(analytics)) : transactionWidget}
                        </Collapse.Panel>
                    </Collapse>
                    ) : null
                }


                {/* chargeback stats*/}
                {MenuAccess('cbm') && !DISABLE_CHARGEBACKS ? (
                    <Collapse style={{ marginBottom: "1.5rem" }} defaultActiveKey={['t1']}>
                        <Collapse.Panel header={t("contents.dashboard.chargeback_info")} key="t1"
                            extra={[
                                <div key="show_all_transaction_widget"  onClick={(e) => e.stopPropagation()}>
                                    <Checkbox
                                        onChange={() => setCheckShowAllChargebackWidget(true)}
                                        checked={checkShowAllChargebackWidget}
                                    >Show all</Checkbox>
                                </div>
                            ]}
                        >
                            { loadChargebackWidget() }
                        </Collapse.Panel>
                    </Collapse>
                    ) : null
                }

                {/* chargeback issuer*/}
                {MenuAccess("cbm") && !DISABLE_CHARGEBACKS ? (
                    <Collapse style={{ marginBottom: "1.5rem" }} defaultActiveKey={["t1"]}>
                        <Collapse.Panel
                        header={t("contents.dashboard.chargebacks_by_issuer")}
                        key="t1"
                        extra={
                            <div
                            onClick={(e) => e.stopPropagation()}
                            style={{ color: "#1890ff", cursor: "pointer", userSelect: "none" }}
                            onMouseDown={(e) => e.preventDefault()}
                            onClickCapture={() => setShowAllChargebackWidget((prev) => !prev)}
                            >
                            {showAllChargebackWidget ? (
                                <>
                                Collapse <UpOutlined />
                                </>
                            ) : (
                                <>
                                Show all <DownOutlined />
                                </>
                            )}
                            </div>
                        }
                        >
                        {loadChargebackIssuerWidget()}
                        </Collapse.Panel>
                    </Collapse>
                    ) : null}


                {PermissionsRequired("SYSADMIN|ALERTSTATS") && MenuAccess('alerts') && !DISABLE_ALERTS && data ? (
                    <Row gutter={[16, 16]} style={{ marginBottom: "1.5rem" }}>
                        <Col sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 9 }}>
                            <Card size="small" title={`${t(`contents.months.${currentMonthName}`)}'s ${t("contents.dashboard.alerts")} `} style={{ minHeight: "506px" }}>
                                {data.alerts ? <AlertsPieChart t={t} data={data.alerts ? checkTranslation(data.alerts.piechart) : []} /> : null}
                                
                            </Card>
                        </Col>
                        <Col sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 15 }}>
                            <Card size="small" title={t("contents.dashboard.alerts_chart2")} key="AlertsLineChart"
                                extra={[
                                    <RangePicker key="DateRange"
                                        value={dates}
                                        format={dateFormat}
                                        onOpenChange={onOpenChange}
                                        onChange={(val) => onDatesChange(val)}
                                    />
                                ]}
                            >

                                {data.alerts ? <AlertsLineChart t={t} data={data.alerts.linechart ? data.alerts.linechart : []} /> : null}
                            </Card>
                        </Col>
                    </Row>
                    ) : null
                }

                {(PermissionsRequired("SYSADMIN") || MenuAccess('fraudchecks')) && fraudcheckData ? (
                    <Row gutter={[16, 16]}>
                        <Col sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 9 }}>
                            <Card size="small" title={`${t(`contents.months.${currentMonthName}`)}'s ${t("contents.dashboard.fraudchecks")} `} style={{ minHeight: "506px" }} extra={<span style={{fontWeight:"600"}}> {t("contents.dashboard.approval_rate") + ": " + fraudcheckData.fraudcheck.piechartRate} </span>}>
                                {fraudcheckData.fraudcheck ? <FraudCheckPieChart t={t} data={fraudcheckData.fraudcheck.piechart ? checkTranslation(fraudcheckData.fraudcheck.piechart) : []} /> : null}
                            </Card>
                        </Col>
                        <Col sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 15 }}>
                            <Card size="small" title={t("contents.dashboard.fraudchecks_daily_volume")} key="AlertsLineChart"
                                extra={[
                                    <RangePicker key="DateRange"
                                        value={fraudcheckDates}
                                        format={dateFormat}
                                        onChange={(val) => onDatesChangeFraudCheckChart(val)}
                                    />
                                ]}
                            >

                                {fraudcheckData.fraudcheck ? <FraudCheckLineChart t={t} data={fraudcheckData.fraudcheck.linechart ? fraudcheckData.fraudcheck.linechart : []} /> : null}
                            </Card>
                        </Col>
                    </Row>
                    ) : null
                }
            </div>
        </div>
    );
};

export default Dashboard;
